import { combineReducers } from 'redux';
import auth from './auth';
import merchant from './merchant';

export default combineReducers({
  auth,
  merchant,
});
